export default "__VITE_ASSET__a8dfa8f6__"